import api from "./api";
import logger from "../utils/logger";

function createChildSearchService() {

    function searchChildren(searchTerm, maxResults = 0, centreId) {
        if (!searchTerm || !searchTerm.trim()) {
            return Promise.reject(new Error("Search term is required"));
        }

        logger.debug("Searching for children with term:", searchTerm, "maxResults:", maxResults, "centreId:", centreId);

        // Handle multiple centre IDs by making multiple API calls
        const centreIds = Array.isArray(centreId) ? centreId : [centreId].filter(id => id != null);

        if (centreIds.length === 0) {
            // No centre ID specified, search without centre filter
            return api.searchChildren(searchTerm.trim(), maxResults, null)
                .then((response) => {
                    const children = Array.isArray(response) ? response : [];
                    logger.debug("Found children (no centre filter):", children.length);
                    return children;
                })
                .catch((error) => {
                    logger.error("Error searching children:", error);
                    throw error;
                });
        }

        // Search in all specified centres
        const searchPromises = centreIds.map(id => 
            api.searchChildren(searchTerm.trim(), maxResults, id)
                .catch(error => {
                    logger.warn(`Error searching centre ${id}:`, error);
                    return []; // Return empty array on error for this centre
                })
        );

        return Promise.all(searchPromises)
            .then((responses) => {
                // Flatten and deduplicate results
                const allChildren = responses.flat();
                const uniqueChildren = allChildren.filter((child, index, self) => 
                    index === self.findIndex(c => c.childId === child.childId)
                );
                logger.debug(`Found ${uniqueChildren.length} unique children across ${centreIds.length} centres`);
                return uniqueChildren;
            })
            .catch((error) => {
                logger.error("Error searching children across centres:", error);
                throw error;
            });
    }
    
    function getChildDetails(childId){
        if (!childId) {
            return Promise.reject(new Error("Child ID is required"));
        }

        logger.debug("Fetching details for child:", childId);

        return api.getChildDetails(childId)
            .then((response) => {
                logger.debug("Child details fetched successfully");
                return response;
            })
            .catch((error) => {
                logger.error("Error fetching child details:", error);
                throw error;
            });
    }

    return {
        searchChildren,
        getChildDetails
    };
}

// Export the factory function
export { createChildSearchService };

// Export a singleton instance as default for backward compatibility
const childSearchService = createChildSearchService();
export default childSearchService;